import { render, staticRenderFns } from "./VirtualCurrency.vue?vue&type=template&id=46705126&scoped=true&"
import script from "./VirtualCurrency.vue?vue&type=script&lang=js&"
export * from "./VirtualCurrency.vue?vue&type=script&lang=js&"
import style0 from "./VirtualCurrency.vue?vue&type=style&index=0&id=46705126&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46705126",
  null
  
)

export default component.exports